import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import userflow from 'userflow.js';
import { RootState } from '@/reducers/reducers';
import { AppComponentProps } from '@/typescriptHelpers';
import { selectIsUserflowOnboardingEnabledForOrg } from '@/selectors/selectors';
import * as Storage from '@/helpers/localStorageHelper';
import { trackUserEvent } from '@/actions/trackEvent';
import { Event } from '@/utils/analytics';
import { USERFLOW_ONBOARDING_FLOW_ID } from '@/constants';
import { useShouldShowOnboarding } from './QualitativeOnboardingTaskList';

export const UserflowOnboarding: React.FC<AppComponentProps> = ({ orgId, appId }) => {
    const dispatch = useDispatch();

    const isUserflowOnboardingEnabled = useSelector((state: RootState) =>
        selectIsUserflowOnboardingEnabledForOrg(state, orgId),
    );

    const [onboardingDismissed, setOnboardingDismissed] = React.useState(Storage.getOnboardingDismissedForAppId(appId));

    const shouldShowOnboarding = useShouldShowOnboarding(orgId, appId, onboardingDismissed);

    React.useEffect(() => {
        if (isUserflowOnboardingEnabled && shouldShowOnboarding) {
            userflow.start(USERFLOW_ONBOARDING_FLOW_ID);
        }
    }, [isUserflowOnboardingEnabled, shouldShowOnboarding]);

    React.useEffect(() => {
        const onChecklistEnded = (event) => {
            if (event.checklist?.id !== USERFLOW_ONBOARDING_FLOW_ID) {
                return;
            }

            setOnboardingDismissed(true);
            Storage.setOnboardingDismissedForAppId(appId, true);
            dispatch(trackUserEvent({ orgId, appId, eventName: Event.ClickDismissOnboarding }));
        };

        userflow.on('checklistEnded', onChecklistEnded);
        return () => userflow.off('checklistEnded', onChecklistEnded);
    }, [orgId, appId]);

    return null;
};
